import {
  cloneObjectiveApi,
  deleteObjectiveApi,
  getChildObjectivesApi,
  getObjectiveApi,
  getObjectiveHierarchyApi,
  getParentLevelVisibleForDeleteRealignApi,
  getTimeBoundObjectivesApi,
  realignObjectiveApi,
  saveObjectiveApi,
  updateObjectiveApi,
} from 'api/objective';
import Objective from 'models/okr/objective';
import OrgObjective from 'models/orgObjective';

import { OKR_TAG_TYPES } from 'constants/ProjectConstants';

export const getChildObjectives = async ({ objectiveId, timeboundDetailsId }) =>
  getChildObjectivesApi({ objectiveId, timeboundDetailsId }).then((res) => res.entity);

export const saveObjective = async ({ tag, isSubObjective = false, uiKey = '', toIds = [], parentPost = null }) => {
  const res = await saveObjectiveApi({
    objectiveTimeBound: OrgObjective.getAPIStructure({
      ...tag,
      displayName: tag.name,
      objectiveType: isSubObjective || tag.parentTag ? 'SUB_OBJECTIVE_TAG' : tag.objectiveType,
    }),
    uiKey,
    toIds: toIds.map(({ id: uuid, ownerType }) => ({ uuid, ownerType })),
    parentPost,
    taskType: isSubObjective ? OKR_TAG_TYPES.SUB_OKR_TAG : OKR_TAG_TYPES.OKR_TAG,
  });
  return Objective.fromJSON(res.entity);
};

export const getObjective = async ({ objectivePId }) => {
  const res = await getObjectiveApi({
    objectivePId,
  });
  return Objective.fromJSON(res.entity);
};

export const updateObjective = async ({
  objectivePId,
  tag,
  isSubObjective = false,
  uiKey = '',
  toIds = [],
  parentPost = null,
  updateAllInstances,
  renameObjective,
}) => {
  const res = await updateObjectiveApi({
    objectivePId,
    objectiveTimeBound: OrgObjective.getAPIStructure({
      ...tag,
      displayName: tag.name,
      objectiveType: isSubObjective || tag.parentTag ? 'SUB_OBJECTIVE_TAG' : tag.objectiveType,
    }),
    uiKey,
    toIds: toIds.map(({ id: uuid, ownerType }) => ({ uuid, ownerType })),
    parentPost: typeof parentPost === 'object' ? { uuid: parentPost?.uuid } : null,
    renameObjective,
    updateAllInstances,
  });
  return Objective.fromJSON(res.entity);
};

export const getObjectiveHierarchy = async ({ objectiveTimeBoundId }) =>
  getObjectiveHierarchyApi({ objectiveTimeBoundId }).then((res) => res.entity);

export const getTimeBoundObjectives = async ({ timePeriodObj, parentId = null }) => {
  const res = await getTimeBoundObjectivesApi({
    startTS: timePeriodObj.startTS,
    endTS: timePeriodObj.endTS,
    timelineTag: timePeriodObj.timelineTag,
    parentId,
    tagType: parentId ? 'SUB_OBJECTIVE_TAG' : 'GOAL',
  });

  return res.entity.map((objective) => {
    const orgObjective = OrgObjective.fromJSON(objective);
    return {
      parentPostCardId: objective?.parentPostCardId,
      postCardId: objective?.postCardId,
      ...orgObjective,
    };
  });
};

export const realignObjective = async ({
  timePeriodObj,
  parentId = null,
  realignId,
  targetObjectiveTimeBoundId,
  isDeleteRealign = false,
}) => {
  const queryParamsObj = {
    startTS: timePeriodObj.startTS,
    endTS: timePeriodObj.endTS,
    timelineTag: timePeriodObj.timelineTag,
    realignId,
    parentId,
    targetObjectiveTimeBoundId,
    isDeleteRealign,
  };
  const res = await realignObjectiveApi(queryParamsObj);

  return res.entity;
};

export const deleteObjective = async ({ objectiveTimeBoundId, archiveObjectiveTree, isDeleteRevamp }) => {
  const res = await deleteObjectiveApi({
    objectiveTimeBoundId,
    archiveObjectiveTree,
    isDeleteRevamp,
  });

  return res.entity;
};

export const cloneObjective = async ({ tag, includeObjectiveTree = false }) => {
  const res = await cloneObjectiveApi({
    tag: OrgObjective.getAPIStructure({
      ...tag,
      displayName: tag.name,
    }),
    objectiveTimeBoundId: tag.objectiveTimeBoundId,
    includeObjectiveTree,
  });
  return res.entity;
};

export const getParentLevelVisibleForDeleteRealign = async ({ objectiveTimeBoundId }) => {
  const res = await getParentLevelVisibleForDeleteRealignApi({ objectiveTimeBoundId });

  return res.entity;
};
